import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Chip,
  IconButton,
  Grid,
  useTheme,
  Paper,
  Avatar,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Close as CloseIcon,
  AttachMoney as AttachMoneyIcon,
  Category as CategoryIcon,
  ShoppingBag as ShoppingBagIcon,
  Link as LinkIcon,
  Image as ImageIcon,
  LocationOn as LocationOn,
  CurrencyRupee,
} from "@mui/icons-material";
import useAxios from "../../useAxios";
import { AddCircleOutline } from "@mui/icons-material";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "90%", md: "80%" },
  maxWidth: 800,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 4,
  p: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

const EditDeleteModal = ({
  open,
  handleClose,
  mode, // 'category' or 'product'
  data,
  onSave,
  onDelete,
}) => {
  const theme = useTheme();
  const [formData, setFormData] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [editingPriceIndex, setEditingPriceIndex] = useState(null);
  const [newPriceKey, setNewPriceKey] = useState("");
  const [newPriceValue, setNewPriceValue] = useState("");
  const [prices, setPrices] = useState([]);
  const [initialFormData, setInitialFormData] = useState({});
  const [initialPrices, setInitialPrices] = useState([]);
  const [initialCityOptions, setInitialCityOptions] = useState([]);
  const [lastInput, setLastInput] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [initialCustomPricesMap, setInitialCustomPricesMap] = useState({});
  const [customPricesMap, setCustomPricesMap] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const axiosData = useAxios();
  const isEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };
  const isChanged =
    !isEqual(formData, initialFormData) ||
    !isEqual(prices, initialPrices) ||
    !isEqual(customPricesMap, initialCustomPricesMap);
  useEffect(() => {
    if (open && data) {
      if (mode === "category") {
        setPrices([]);
        setFormData({
          name: data.name || "",
          productList: data.productList?.join("\n") || "",
        });
      } else if (mode === "product") {
        setPrices(data.price || []);
        setFormData({
          produt_name: data.produt_name || "",
          productCategory: data.productCategory || "",
          deliverables: data.deliverables?.join("\n") || "",
          materials_list: data.materials_list?.join("\n") || "",
          reqFromClient: data.reqFromClient?.join("\n") || "",
          videoLink: data.videoLink || "",
          image_local_url: data?.image_local_url || "",
        });
      }
    } else {
      setFormData({});
    }
    setConfirmDelete(false);
    setEditingPriceIndex(null);
  }, [open, data, mode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Convert to Base64
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64Image = reader.result;
       setImageFile({
      name: file.name,
      type: file.type,
      base64: reader.result.split(",")[1], // remove data:image/... part
    });
      // Set the returned URL/path in the TextField
      setFormData({
        ...formData,
        image_local_url: file.name, // example: "/assets/img.jpg"
      });
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    let formattedData;

    if (mode === "category") {
      formattedData = {
        ...data,
        name: formData.name,
        productList: formData.productList
          ? formData.productList
              .split("\n")
              .filter((item) => item.trim() !== "")
          : [],
      };
    } else {
      formattedData = {
        ...data,
        ...formData,
        deliverables: formData.deliverables
          .split("\n")
          .filter((item) => item.trim() !== ""),
        materials_list: formData.materials_list
          .split("\n")
          .filter((item) => item.trim() !== ""),
        reqFromClient: formData.reqFromClient
          .split("\n")
          .filter((item) => item.trim() !== ""),
        price: prices,
        image: imageFile ,
      };
      Object.keys(customPricesMap).forEach((key) => {
        formattedData[key] = customPricesMap[key];
      });
      // ? NEW: Identify & add new cities to backend
      // const newCities = cityOptions.filter(
      //   (city) => !initialCityOptions.includes(city)
      // );

      // if (newCities.length > 0) {
      //   await axiosData.put("editGeneralData/generaldata", {
      //     dataName: "cities",
      //     datasList: [...initialCityOptions, ...newCities],
      //   });
      //   setInitialCityOptions([...initialCityOptions, ...newCities]); // update local ref
      //   await fetchCities();
      // }
    }

    onSave(formattedData);
    handleClose();
  };
  const handleAddNewCity = async (cityNew) => {
    try {
      // const newCities = cityOptions.filter(
      //   (city) => !initialCityOptions.includes(city)
      // );
      const newvalueFormat = cityNew.charAt(0).toUpperCase() + cityNew.slice(1);
      await axiosData.put("editGeneralData/generaldata", {
        dataName: "cities",
        datasList: [...initialCityOptions, newvalueFormat],
      });
      setInitialCityOptions([...initialCityOptions, newvalueFormat]); // update local ref
      await fetchCities();
    } catch (err) {
      console.error("Error adding new city", err);
    }
  };
  const handleDeleteConfirm = () => {
    // if (!confirmDelete) {
    //   setConfirmDelete(true);
    //   return;
    // }
    onDelete(data);
    handleClose();
  };

  const handlePriceEdit = (index) => {
    setEditingPriceIndex(index);
  };
  const handlePriceChange = (index, value) => {
    const updated = [...prices];
    const key = Object.keys(updated[index])[0];
    updated[index] = { [key]: value };
    setPrices(updated);
  };

  const handlePriceSave = (index) => {
    setEditingPriceIndex(null);
  };
  const handlePriceKeyChange = (index, newKey) => {
    const updated = [...prices];
    const oldKey = Object.keys(updated[index])[0];
    const value = updated[index][oldKey];

    updated[index] = { [newKey]: value }; // ? Update key while preserving value
    setPrices(updated);
  };
  // const handlePriceSave = (index) => {
  //   const newPrices = [...data.price];
  //   const key = Object.keys(newPrices[index])[0];
  //   newPrices[index] = { [key]: newPrices[index][key] };
  //   onSave({ ...data, price: newPrices });
  //   setEditingPriceIndex(null);
  // };

  // const handlePriceChange = (index, value) => {
  //   const newPrices = [...data.price];
  //   const key = Object.keys(newPrices[index])[0];
  //   newPrices[index] = { [key]: value };
  //   //onSave({ ...data, price: newPrices });
  // };
  const handleAddPrice = () => {
    if (newPriceKey && newPriceValue !== "") {
      const newPrice = { [newPriceKey]: newPriceValue };
      setPrices((prev) => [...prev, newPrice]);
      setNewPriceKey("");
      setNewPriceValue("");
    }
  };

  const handleRemovePrice = (index) => {
    const updated = [...prices];
    updated.splice(index, 1);
    setPrices(updated);
  };
  /* Get cities list from api*/
  const fetchCities = async () => {
    try {
      const data = await axiosData.get(`getGeneralDataByName/cities`);
      if (data) {
        const dataCities = data.data.generalData;
        setCityOptions(dataCities.datasList);
        setInitialCityOptions(dataCities.datasList);
      }
    } catch (err) {
      console.log("Error", err);
    }
  };
  useEffect(() => {
    if (open && data) {
      if (mode === "category") {
        const formObj = {
          name: data.name || "",
          productList: (data.productList || []).join("\n"),
        };
        setFormData(formObj);
        setInitialFormData(formObj);
      } else if (mode === "product") {
        const formObj = {
          produt_name: data.produt_name || "",
          productCategory: data.productCategory || "",
          deliverables: (data.deliverables || []).join("\n"),
          materials_list: (data.materials_list || []).join("\n"),
          reqFromClient: (data.reqFromClient || []).join("\n"),
          videoLink: data.videoLink || "",
          image_local_url: data.image_local_url || "",
        };
        setFormData(formObj);
        setInitialFormData(formObj);
        setPrices(data.price || []);
        setInitialCustomPricesMap(() => {
          const result = {};
          if (data?.Customization) {
            data.Customization.slice(1).forEach((_, idx) => {
              const key = `price${idx + 1}`;
              result[key] = data[key] || [];
            });
          }
          return result;
        });
        setCustomPricesMap(() => {
          const result = {};
          if (data?.Customization) {
            data.Customization.slice(1).forEach((_, idx) => {
              const key = `price${idx + 1}`;
              result[key] = data[key] || [];
            });
          }
          return result;
        });

        setInitialPrices(data.price || []);
      }
    } else {
      setFormData({});
      setPrices([]);
      setInitialFormData({});
      setInitialPrices([]);
    }

    setConfirmDelete(false);
    setEditingPriceIndex(null);
    fetchCities();
  }, [open, data, mode]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box
          sx={{
            bgcolor: mode === "category" ? "primary.main" : "primary.main",
            color: "white",
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              sx={{
                bgcolor: "white",
                color: mode === "category" ? "primary.main" : "primary.main",
              }}
            >
              {mode === "category" ? <CategoryIcon /> : <ShoppingBagIcon />}
            </Avatar>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {data ? "Edit" : "Add"}{" "}
              {mode === "category" ? "Category" : "Product"}
            </Typography>
          </Box>
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ p: 3, overflowY: "auto", flexGrow: 1 }}>
          {mode === "category" ? (
            <>
              <TextField
                fullWidth
                label="Category Name"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                sx={{ mb: 3 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CategoryIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
              {data && data.name && (
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Products (one per line)"
                  name="productList"
                  value={formData.productList || ""}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ShoppingBagIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </>
          ) : (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Product Name"
                    name="produt_name"
                    value={formData.produt_name || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ShoppingBagIcon color="primary" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Category"
                    name="productCategory"
                    value={formData.productCategory || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CategoryIcon color="primary" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Deliverables (one per line)"
                    name="deliverables"
                    value={formData.deliverables || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Materials List (one per line)"
                    name="materials_list"
                    value={formData.materials_list || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                  />
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Requirements From Client (one per line)"
                    name="reqFromClient"
                    value={formData.reqFromClient || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                  />
                  <TextField
                    fullWidth
                    label="Video Link"
                    name="videoLink"
                    value={formData.videoLink || ""}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon color="primary" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* <TextField
                    fullWidth
                    label="Image URL"
                    name="image_local_url"
                    value={formData.image_local_url || ""}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ImageIcon color="primary" />
                        </InputAdornment>
                      ),
                    }}
                  /> */}
                  <Box display="flex" gap={2}>
                    <TextField
                      fullWidth
                      label="Image URL"
                      name="image_local_url"
                      value={formData.image_local_url || ""}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ImageIcon color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {/* Button to pick image */}
                    {/* <Button
                      variant="contained"
                      component="label"
                      color="secondary"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Change Image
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleImageSelect}
                      />
                    </Button> */}
                  </Box>
                </Grid>
              </Grid>

              {prices && (
                <Box mt={4}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    <AttachMoneyIcon
                      color="primary"
                      sx={{ verticalAlign: "middle", mr: 1 }}
                    />
                    Pricing Options
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  {prices.map((priceItem, index) => {
                    const key = Object.keys(priceItem)[0];
                    const value = priceItem[key];

                    return (
                      <Paper
                        key={index}
                        elevation={2}
                        sx={{
                          mb: 2,
                          p: 2,
                          borderRadius: 2,
                          borderLeft: `4px solid ${theme.palette.primary.main}`,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            boxShadow: theme.shadows[4],
                          },
                        }}
                      >
                        {editingPriceIndex === index ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              gap: 2,
                              alignItems: { xs: "flex-start", sm: "center" },
                              mb: 2,
                              p: 1.5,
                            }}
                          >
                            <Autocomplete
                              freeSolo
                              options={cityOptions || []}
                              value={key}
                              inputValue={key}
                              onInputChange={(event, newInputValue, reason) => {
                                if (reason === "input") {
                                  handlePriceKeyChange(index, newInputValue);
                                  setLastInput(newInputValue);
                                }
                              }}
                              // onBlur={() => {
                              //   if (
                              //     lastInput &&
                              //     !cityOptions.includes(lastInput) &&
                              //     lastInput.trim() !== ""
                              //   ) {
                              //     setCityOptions((prev) => [
                              //       ...prev,
                              //       lastInput.trim(),
                              //     ]);
                              //   }
                              // }}
                              // onKeyDown={(event) => {
                              //   if (event.key === "Enter") {
                              //     event.preventDefault(); // prevent form submit
                              //     const newCity = lastInput?.trim();
                              //     if (
                              //       newCity &&
                              //       !cityOptions.includes(newCity)
                              //     ) {
                              //       setCityOptions((prev) => [
                              //         ...prev,
                              //         newCity,
                              //       ]);
                              //     }
                              //   }
                              // }}
                              onChange={(event, newValue) => {
                                // if (
                                //   newValue &&
                                //   !cityOptions.includes(newValue)
                                // ) {
                                //   //setCityOptions((prev) => [...prev, newValue]);
                                // }
                                setLastInput(newValue || "");
                                handlePriceKeyChange(index, newValue || "");
                              }}
                              renderInput={(params) => {
                                const showAddIcon =
                                  key &&
                                  key.trim() !== "" &&
                                  !cityOptions.includes(
                                    key.trim().charAt(0).toUpperCase() +
                                      key.slice(1)
                                  );
                                return (
                                  <Box
                                    sx={{ position: "relative", width: "100%" }}
                                  >
                                    <TextField
                                      {...params}
                                      label="City"
                                      required
                                      size="small"
                                      sx={{
                                        width: { xs: 235, sm: 250 },
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "8px",
                                          paddingRight: showAddIcon
                                            ? "60px"
                                            : "14px", // Make space for our icon
                                        },
                                      }}
                                      InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <LocationOn color="action" />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                    {showAddIcon && (
                                      <IconButton
                                        onClick={() => {
                                          const newCity = key.trim();
                                          handleAddNewCity(newCity);
                                          // if (
                                          //   newCity &&
                                          //   !cityOptions.includes(newCity)
                                          // ) {
                                          //   setCityOptions((prev) => [
                                          //     ...prev,
                                          //     newCity,
                                          //   ]);
                                          // }
                                        }}
                                        size="small"
                                        sx={{
                                          position: "absolute",
                                          right: "8px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          zIndex: 1300,
                                          backgroundColor: "white", // Background to make it visible
                                          "&:hover": {
                                            backgroundColor: "grey.100",
                                          },
                                        }}
                                      >
                                        <AddCircleOutline
                                          color="primary"
                                          fontSize="small"
                                        />
                                      </IconButton>
                                    )}
                                  </Box>
                                );
                              }}
                            />
                            {/* <TextField
                              value={key}
                              size="small"
                              //disabled
                               onChange={(e) =>
                                handlePriceKeyChange(index, e.target.value)
                              }
                              sx={{ flexGrow: 1 }}
                               InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <LocationOn/>
                                  </InputAdornment>
                                ),
                              }}
                            /> */}
                            <TextField
                              value={value}
                              size="small"
                              onChange={(e) =>
                                handlePriceChange(index, e.target.value)
                              }
                              sx={{
                                flexGrow: 1,
                                width: { xs: "100%", sm: 250 },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CurrencyRupee
                                      sx={{
                                        fontSize: "15px",
                                        textAlign: "center",
                                      }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handlePriceSave(index)}
                              sx={{
                                minWidth: 80,
                                alignSelf: { xs: "center", sm: "center" },
                                mr: { xs: 0.5, sm: 0 },
                              }}
                            >
                              Save
                            </Button>
                          </Box>
                        ) : (
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                              >
                                {key}
                              </Typography>
                              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                <CurrencyRupee
                                  sx={{ fontSize: "15px", textAlign: "center" }}
                                />
                                {value}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => handlePriceEdit(index)}
                                sx={{ color: "primary.main" }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => handleRemovePrice(index)}
                                sx={{ color: "error.main" }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Paper>
                    );
                  })}
                  <Box
                    mt={3}
                    p={2}
                    sx={{ bgcolor: "action.hover", borderRadius: 2 }}
                  >
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      sx={{ fontWeight: 600 }}
                    >
                      Add New Price Option
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: 2,
                        alignItems: { xs: "stretch", sm: "center" },
                        mt: 2,
                      }}
                    >
                      <Autocomplete
                        freeSolo
                        options={cityOptions}
                        value={newPriceKey}
                        inputValue={newPriceKey}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input") {
                            setNewPriceKey(newInputValue);
                            setLastInput(newInputValue);
                          }
                        }}
                        // onBlur={() => {
                        //   if (
                        //     lastInput &&
                        //     !cityOptions.includes(lastInput) &&
                        //     lastInput.trim() !== ""
                        //   ) {
                        //     setCityOptions((prev) => [
                        //       ...prev,
                        //       lastInput.trim(),
                        //     ]);
                        //   }
                        // }}
                        onChange={(event, newValue) => {
                          // if (newValue && !cityOptions.includes(newValue)) {
                          //   setCityOptions((prev) => [...prev, newValue]);
                          // }
                          setNewPriceKey(newValue || "");
                        }}
                        renderInput={(params) => {
                          const showAddIcon =
                            newPriceKey &&
                            newPriceKey.trim() !== "" &&
                            !cityOptions.includes(
                              newPriceKey.trim().charAt(0).toUpperCase() +
                                newPriceKey.slice(1)
                            );
                          return (
                            <Box sx={{ position: "relative", width: "100%" }}>
                              <TextField
                                {...params}
                                label="Location/Type"
                                required
                                size="small"
                                sx={{
                                  width: { xs: 260, sm: 250 },
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    paddingRight: showAddIcon ? "60px" : "14px", // Make space for our icon
                                  },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <LocationOn color="action" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {showAddIcon && (
                                <IconButton
                                  onClick={() => {
                                    const newCity = newPriceKey.trim();
                                    handleAddNewCity(newCity);
                                    // if (
                                    //   newCity &&
                                    //   !cityOptions.includes(newCity)
                                    // ) {
                                    //   setCityOptions((prev) => [
                                    //     ...prev,
                                    //     newCity,
                                    //   ]);
                                    // }
                                  }}
                                  size="small"
                                  sx={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 1300,
                                    backgroundColor: "white", // Background to make it visible
                                    "&:hover": {
                                      backgroundColor: "grey.100",
                                    },
                                  }}
                                >
                                  <AddCircleOutline
                                    color="primary"
                                    fontSize="small"
                                  />
                                </IconButton>
                              )}
                            </Box>
                          );
                        }}
                      />
                      {/* <TextField
                        label="Location/Type"
                        size="small"
                        value={newPriceKey}
                        onChange={(e) => setNewPriceKey(e.target.value)}
                        fullWidth
                      /> */}
                      <TextField
                        label="Price"
                        size="small"
                        //type="number"
                        value={newPriceValue}
                        onChange={(e) => setNewPriceValue(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CurrencyRupee
                                sx={{ fontSize: "15px", textAlign: "center" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleAddPrice}
                        sx={{
                          width: { xs: "100%", sm: "auto" },
                          height: 40,
                          minWidth: { sm: 140 },
                        }}
                      >
                        Add Option
                      </Button>
                    </Box>
                  </Box>
                  {/* Add Customization-based dynamic pricing sections */}
                  {/* --- Customization Pricing Section --- */}
                  {Array.isArray(data?.Customization) &&
                    data.Customization.length > 1 && (
                      <>
                        <Divider sx={{ my: 3 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          Customization-Based Pricing
                        </Typography>

                        {data.Customization.slice(1).map((custom, index) => {
                          const priceKey = `price${index + 1}`;
                          const currentPrices = customPricesMap[priceKey] || [];

                          const updateCustomizationPrices = (newPrices) => {
                            setCustomPricesMap((prev) => ({
                              ...prev,
                              [priceKey]: newPrices,
                            }));
                          };

                          return (
                            <Box key={priceKey} mt={3}>
                              <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 600 }}
                              >
                                Pricing for{" "}
                                {custom === "6*8" ? "6*8 Size" : custom}
                              </Typography>
                              <Divider sx={{ mb: 2 }} />

                              {currentPrices.map((priceItem, pIndex) => {
                                const key = Object.keys(priceItem)[0];
                                const value = priceItem[key];
                                const isEditing =
                                  editingIndex &&
                                  editingIndex.priceKey === priceKey &&
                                  editingIndex.index === pIndex;

                                return (
                                  <Paper
                                    key={pIndex}
                                    elevation={2}
                                    sx={{
                                      p: 2,
                                      mb: 1.5,
                                      borderLeft: `4px solid ${theme.palette.primary.main}`,
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: theme.shadows[4],
                                      },
                                    }}
                                  >
                                    {isEditing ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: {
                                            xs: "column",
                                            sm: "row",
                                          },
                                          gap: 2,
                                          alignItems: {
                                            xs: "flex-start",
                                            sm: "center",
                                          },
                                          mb: 2,
                                          p: 1.5,
                                        }}
                                      >
                                        <Autocomplete
                                          freeSolo
                                          options={cityOptions}
                                          value={key}
                                          inputValue={key}
                                          onInputChange={(e, val) => {
                                            const updated = [...currentPrices];
                                            updated[pIndex] = { [val]: value };
                                            updateCustomizationPrices(updated);
                                          }}
                                          renderInput={(params) => {
                                            const showAddIcon =
                                              key &&
                                              key.trim() !== "" &&
                                              !cityOptions.includes(key.trim());
                                            return (
                                              <Box
                                                sx={{
                                                  position: "relative",
                                                  width: "100%",
                                                }}
                                              >
                                                <TextField
                                                  {...params}
                                                  label="City"
                                                  required
                                                  size="small"
                                                  sx={{
                                                    width: { xs: 235, sm: 250 },
                                                    "& .MuiOutlinedInput-root":
                                                      {
                                                        borderRadius: "8px",
                                                        paddingRight:
                                                          showAddIcon
                                                            ? "60px"
                                                            : "14px", // Make space for our icon
                                                      },
                                                  }}
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        <LocationOn color="action" />
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                                {showAddIcon && (
                                                  <IconButton
                                                    onClick={() => {
                                                      const newCity =
                                                        key.trim();
                                                      if (
                                                        newCity &&
                                                        !cityOptions.includes(
                                                          newCity
                                                        )
                                                      ) {
                                                        setCityOptions(
                                                          (prev) => [
                                                            ...prev,
                                                            newCity,
                                                          ]
                                                        );
                                                      }
                                                    }}
                                                    size="small"
                                                    sx={{
                                                      position: "absolute",
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      zIndex: 1300,
                                                      backgroundColor: "white", // Background to make it visible
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "grey.100",
                                                      },
                                                    }}
                                                  >
                                                    <AddCircleOutline
                                                      color="primary"
                                                      fontSize="small"
                                                    />
                                                  </IconButton>
                                                )}
                                              </Box>
                                            );
                                          }}
                                        />
                                        <TextField
                                          size="small"
                                          value={value}
                                          onChange={(e) => {
                                            const updated = [...currentPrices];
                                            updated[pIndex] = {
                                              [key]: e.target.value,
                                            };
                                            updateCustomizationPrices(updated);
                                          }}
                                          sx={{
                                            flexGrow: 1,
                                            width: { xs: "100%", sm: 250 },
                                          }}
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <CurrencyRupee
                                                  sx={{
                                                    fontSize: "15px",
                                                    textAlign: "center",
                                                  }}
                                                />
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                        <Button
                                          variant="contained"
                                          size="small"
                                          onClick={() => setEditingIndex(null)}
                                          sx={{
                                            minWidth: 80,
                                            alignSelf: {
                                              xs: "center",
                                              sm: "center",
                                            },
                                            mr: { xs: 0.5, sm: 0 },
                                          }}
                                        >
                                          Save
                                        </Button>
                                      </Box>
                                    ) : (
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                      >
                                        <Box>
                                          <Typography
                                            variant="subtitle2"
                                            color="text.secondary"
                                          >
                                            {key}
                                          </Typography>
                                          <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 600 }}
                                          >
                                            <CurrencyRupee
                                              sx={{
                                                fontSize: "15px",
                                                textAlign: "center",
                                              }}
                                            />
                                            {value}
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: 1,
                                            flexWrap: "wrap",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              setEditingIndex({
                                                priceKey,
                                                index: pIndex,
                                              })
                                            }
                                            sx={{ color: "primary.main" }}
                                          >
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              const updated = [
                                                ...currentPrices,
                                              ];
                                              updated.splice(pIndex, 1);
                                              updateCustomizationPrices(
                                                updated
                                              );
                                            }}
                                            sx={{ color: "error.main" }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </Box>
                                      </Box>
                                    )}
                                  </Paper>
                                );
                              })}

                              {/* Add new customization price */}
                              <Box
                                mt={2}
                                display="flex"
                                flexWrap="wrap"
                                gap={2}
                              >
                                <Autocomplete
                                  freeSolo
                                  options={cityOptions}
                                  value={newKey}
                                  onInputChange={(e, val) => setNewKey(val)}
                                  renderInput={(params) => {
                                    const showAddIcon =
                                      newKey &&
                                      newKey.trim() !== "" &&
                                      !cityOptions.includes(newKey.trim());
                                    return (
                                      <Box
                                        sx={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <TextField
                                          {...params}
                                          label="City"
                                          size="small"
                                          sx={{
                                            width: { xs: 260, sm: 250 },
                                            "& .MuiOutlinedInput-root": {
                                              borderRadius: "8px",
                                              paddingRight: showAddIcon
                                                ? "60px"
                                                : "14px", // Make space for our icon
                                            },
                                          }}
                                          InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <LocationOn color="action" />
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                        {showAddIcon && (
                                          <IconButton
                                            onClick={() => {
                                              const newCity = newKey.trim();
                                              if (
                                                newCity &&
                                                !cityOptions.includes(newCity)
                                              ) {
                                                setCityOptions((prev) => [
                                                  ...prev,
                                                  newCity,
                                                ]);
                                              }
                                            }}
                                            size="small"
                                            sx={{
                                              position: "absolute",
                                              right: "8px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              zIndex: 1300,
                                              backgroundColor: "white", // Background to make it visible
                                              "&:hover": {
                                                backgroundColor: "grey.100",
                                              },
                                            }}
                                          >
                                            <AddCircleOutline
                                              color="primary"
                                              fontSize="small"
                                            />
                                          </IconButton>
                                        )}
                                      </Box>
                                    );
                                  }}
                                />
                                <TextField
                                  label="Price"
                                  size="small"
                                  value={newValue}
                                  onChange={(e) => setNewValue(e.target.value)}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CurrencyRupee
                                          sx={{
                                            fontSize: "15px",
                                            textAlign: "center",
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <Button
                                  variant="contained"
                                  startIcon={<AddIcon />}
                                  onClick={() => {
                                    if (!newKey || newValue === "") return;
                                    const updated = [
                                      ...currentPrices,
                                      { [newKey]: newValue },
                                    ];
                                    updateCustomizationPrices(updated);
                                    setNewKey("");
                                    setNewValue("");
                                  }}
                                  sx={{
                                    width: { xs: "100%", sm: "auto" },
                                    height: 40,
                                    // minWidth: { sm: 100 },
                                  }}
                                >
                                  Add
                                </Button>
                              </Box>
                            </Box>
                          );
                        })}
                      </>
                    )}
                </Box>
              )}
            </>
          )}
        </Box>

        <Box
          sx={{
            p: 2,
            bgcolor: "grey.100",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {data && (
            <Button
              variant={confirmDelete ? "contained" : "outlined"}
              color="error"
              onClick={handleDeleteConfirm}
              startIcon={<DeleteIcon />}
              sx={{
                borderRadius: 2,
                px: 3,
                width: { xs: "100%", sm: "auto" },
                ...(confirmDelete && {
                  animation: "pulse 1.5s infinite",
                  "@keyframes pulse": {
                    "0%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.05)" },
                    "100%": { transform: "scale(1)" },
                  },
                }),
              }}
            >
              {/* {confirmDelete ? 'Confirm Delete' : 'Delete'} */}
              Delete
            </Button>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              alignItems: {
                xs: "stretch",
                sm: "center",
                md: "center",
                lg: "center",
              },
            }}
          >
            <Button
              variant="text"
              onClick={handleClose}
              sx={{
                mr: 2,
                borderRadius: 2,
                px: 3,
                color: "text.secondary",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!isChanged}
              sx={{
                borderRadius: 2,
                px: 4,
                width: { xs: "100%", sm: "auto" },
                bgcolor: mode === "category" ? "primary.main" : "primary.main",
                "&:hover": {
                  bgcolor:
                    mode === "category" ? "primary.dark" : "primary.dark",
                },
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditDeleteModal;
